import React, { Component } from 'react';
import "../../css/CalendarView.scss";
import Utility from '../../utility/Utility';
import { FULL_MONTHS, WEEK_DAYS } from '../../constants/Constant';
import { isEqual } from 'lodash';
import ic_check_mark_circle from "../../assets/icons/white/ic_check-mark_circle.png";
import ic_check_mark_circle_done from "../../assets/icons/white/ic_check-mark_circle_done.png";
import { reverseTimezoneOffset, scrollTo } from '../../managers/common/CommonUtil';
import moment from 'moment';
import {DKLine} from 'deskera-ui-library'
import { CALENDAR_VIEW } from '../timesheet/TimesheetConstants';

const time = new Date().toString()?.match(/GMT\+[0-9]+/) && new Date().toString()?.match(/GMT\+[0-9]+/).length !=0 ? new Date().toString()?.match(/GMT\+[0-9]+/)[0]:""
const AM_HOURS = [{ title: time, format: '-1' },{ title: '12 AM', format: '0' }, { title: '1 AM', format: '1' }, { title: '2 AM', format: '2' }, { title: '3 AM', format: '3' }, { title: '4 AM', format: '4' }, { title: '5 AM', format: '5' }, { title: '6 AM', format: '6' }, { title: '7 AM', format: '7' }, { title: '8 AM', format: '8' }, { title: '9 AM', format: '9' }, { title: '10 AM', format: '10' }, { title: '11 AM', format: '11' }];
const PM_HOURS = [{ title: '12 PM', format: '12' }, { title: '1 PM', format: '13' }, { title: '2 PM', format: '14' }, { title: '3 PM', format: '15' }, { title: '4 PM', format: '16' }, { title: '5 PM', format: '17' }, { title: '6 PM', format: '18' }, { title: '7 PM', format: '19' }, { title: '8 PM', format: '20' }, { title: '9 PM', format: '21' }, { title: '10 PM', format: '22' }, { title: '11 PM', format: '23' }];

class WeekViewCalendar extends Component {
    timeLineHeight = 40;
    constructor(props) {
        super(props)
        this.state = {
            weekDays: this.getWeek(),
            monthAndYear: this.props?.monthAndYear
        }
        this.calenderRef = React.createRef();
        this.today = new Date();
        this.month = new Date().getMonth();
        this.year = new Date().getFullYear();
        this.firstDay = new Date(this.year, this.month).getDay();
    }
    componentDidMount() {
        setTimeout(()=>{
            scrollTo(document.getElementById(moment().format("h A")))

        },500)
        this.interval = setInterval(()=>{
            this.setState({
                ...this.state
            })
        },1000)
    }
    componentWillUnmount() {
        if(this.interval) {
            clearInterval(this.interval)
        }
    }

    getWeek = () => {
        const { month, year } = this.getMonthAndYearFromString(this.props?.monthAndYear);
        let index = FULL_MONTHS.findIndex(mon => mon === month);
        const date = new Date().getFullYear().toString() == year && FULL_MONTHS[new Date().getMonth()] == month ? new Date() : new Date(year, index, 1, 0, 0);
        return this.selectWeek(new Date(date));
    }

    componentWillReceiveProps(nextProps) {
        if (!isEqual(nextProps.monthAndYear, this.props?.monthAndYear || FULL_MONTHS[new Date().getMonth()] + " " + new Date().getFullYear())) {
            const { month, year } = this.getMonthAndYearFromString(nextProps.monthAndYear);
            const index = FULL_MONTHS.findIndex(mon => mon === month);

            if (nextProps?.prevButtonTapped) {
                const date = new Date(year, index, 0, 0, 0);
                this.setState({ weekDays: this.selectWeek(new Date(date))});
            } else if (nextProps?.nextButtonTapped) {
                const date = new Date(year, index, 1, 0, 0);
                this.setState({ weekDays: this.selectWeek(new Date(date))});
            }
        }
        if (nextProps?.prevButtonTapped) {
            this.prevClick();
        } else if (nextProps?.nextButtonTapped) {
            this.nextClick();
        } else if (nextProps?.todayTapped) {
            this.setState({ weekDays: this.selectWeek(new Date()) })
        }
    }

    nextClick = () => {
        let lastWeekEndDate = new Date(this.state.weekDays[6]).setDate(new Date(this.state.weekDays[6]).getDate() + 1);
        this.setState({ weekDays: this.selectWeek(new Date(lastWeekEndDate)) }, () => {
            this.props?.weekStartDate(new Date(this.state.weekDays[0]))
            this.props?.weekEndDate(new Date(this.state.weekDays[6]))
        });
    }

    prevClick = () => {
        let lastWeekStartDate = new Date(this.state.weekDays[0]).setDate(new Date(this.state.weekDays[0]).getDate() - 7);
        this.setState({ weekDays: this.selectWeek(new Date(lastWeekStartDate)) }, () => {
            this.props?.weekStartDate(new Date(this.state.weekDays[0]))
            this.props?.weekEndDate(new Date(this.state.weekDays[6]))
        });

    }

    selectWeek(date) {
        return Array(7).fill(new Date(date)).map((el, idx) =>
            new Date(el.setDate(el.getDate() - el.getDay() + idx)))
    }

    getMonthAndYearFromString = (monthYearString) => {
        const splittedArray = monthYearString?.split(' ');
        return { month: splittedArray?.[0] || FULL_MONTHS[new Date().getMonth()], year: splittedArray?.[1] || new Date().getFullYear() }
    }

    isTaskDate(task, hour, date) {
        const day = (date);
        const taskFromDate = new Date(moment(task.fromDate).format());
        const taskToDate = new Date(moment(task.toDate).format());
        let tFromDate = `${taskFromDate.getDate()}/${taskFromDate.getMonth()+1}/${taskFromDate.getFullYear()}`;
        let tToDate = `${taskToDate.getDate()}/${taskToDate.getMonth()+1}/${taskToDate.getFullYear()}`;
        let currentDate = `${day.getDate()}/${day.getMonth()+1}/${day.getFullYear()}`
        let isBetWeen = (moment(currentDate,'DD/MM/YYYY').isBetween(moment(tFromDate,'DD/MM/YYYY'),moment(tToDate,'DD/MM/YYYY')))
        let isSameToDate = (moment(currentDate,'DD/MM/YYYY').isSame(moment(tToDate,'DD/MM/YYYY')))
        
        return (
            (
                taskFromDate.getHours() == hour.format
            && taskFromDate.getDate() == day.getDate()
            && taskFromDate.getMonth() == day.getMonth()
            && taskFromDate.getFullYear() == day.getFullYear()
            )
            //Note: will use leter ||(
            //         (
            //             (isBetWeen && hour.format === '0') 
            //             || (isSameToDate && hour.format === '0')
            //         ) &&
            //         (
            //             taskFromDate.getDate() != day.getDate()
            //         )
            //     )
        )
    }

    renderTask = (date, hour) => {
        return this.props?.tasks?.map((task) => {
            if (this.isTaskDate(task, hour, date)) {
                return (
                    <div className="z-index-1"onClick={(e) => { e.stopPropagation(); this.props.onShowTask(task); }}>
                        {this.props?.taskRenderer(task,CALENDAR_VIEW.WEEK,null,date)}
                    </div>
                );
            }
        });
    }

    render() {
        return (
            <div>
                {/* <table className="table parent-width p-m pb-l" id="calendar" ref={this.calenderRef}>
                    <thead className="parent-width">
                        <tr className="parent-width pt-l">
                            <th style={{ width: '100px' }}></th>
                            {WEEK_DAYS.map((day, index) => {
                                const isToday = this.today.getDate() === new Date(this.state.weekDays[index]).getDate() && this.month === new Date(this.state.weekDays[index]).getMonth() && this.year === new Date(this.state.weekDays[index]).getFullYear();
                                return (
                                    <th style={{ fontWeight: "500", height: '80px' }}>
                                        <div className={`text-gray`}>{day}</div>
                                        <div className={`justify-content-center `} style={{ display: 'flex' }}>
                                            <div onClick={() => this.props?.onDateClick(new Date(this.state?.weekDays[index]))} className={`fs-xl cursor-hand ${isToday ? 'bg-gray1 p-m' : 'listPickerBG p-m'}`} style={{ color: isToday ? 'text-white' : 'text-black', width: 'auto', minWidth: '10%', borderRadius: '50%' }}>
                                                {new Date(this.state?.weekDays[index])?.getDate()}
                                            </div>
                                        </div>
                                    </th>
                                )
                            })}
                        </tr>
                    </thead>
            </table> */}
            <div className="parent-width column border-box bg-white border-radius-s show-scroll-bar align-self-start shadow-s display-only-web calendar-view" id="calendar-wrapper" style={{height:'calc(100vh - 300px)',overflow:'scroll'}}>
                <table className="table parent-width p-m pb-l" id="calendar" ref={this.calenderRef}>
                    <thead className="parent-width">
                        <tr className="parent-width pt-l">
                            <th style={{ width: '100px' }}></th>
                            {WEEK_DAYS.map((day, index) => {
                                const isToday = this.today.getDate() === new Date(this.state.weekDays[index]).getDate() && this.month === new Date(this.state.weekDays[index]).getMonth() && this.year === new Date(this.state.weekDays[index]).getFullYear();
                                return (
                                    <th style={{ fontWeight: "500", height: '80px' }}>
                                        <div className={`text-gray`}>{day}</div>
                                        <div className={`justify-content-center `} style={{ display: 'flex' }}>
                                            <div onClick={() => this.props?.onDateClick(new Date(this.state?.weekDays[index]))} className={`fs-xl cursor-hand ${isToday ? 'bg-gray1 p-m' : 'listPickerBG p-m'}`} style={{ color: isToday ? 'text-white' : 'text-black', width: 'auto', minWidth: '10%', borderRadius: '50%' }}>
                                                {new Date(this.state?.weekDays[index])?.getDate()}
                                            </div>
                                        </div>
                                    </th>
                                )
                            })}
                        </tr>
                    </thead>
                    <tbody id="calendar-body">
                        {[...AM_HOURS, ...PM_HOURS].map(hour => {
                            return (
                                <tr>
                                    <td className="text-gray fs-s" key={hour.title} id={hour.title} style={{ border: "none", position:"relative", top:-22 }}>{hour.title}</td>
                                    {WEEK_DAYS.map((day, index) => {
                                        return (
                                            <td
                                                className=" cursor-hand position-relative"
                                                style={{ height: `${this.timeLineHeight}px` }}
                                                onClick={(e) => {
                                                    this.props?.onAddTask(e, new Date(this.state?.weekDays[index]), hour)
                                                }}
                                            >
                                                {/* current Timeline */}
                                                { (moment().day() === index && moment().format("h A") == hour.title) &&
                                                    <div className="d-flex">
                                                        <div className="bg-red p-xs border-radius-m z-index-2" style={{ position: 'absolute', top: ((parseInt(moment().format('mm')) * this.timeLineHeight) / 60)-2 , left: -2 }}></div>
                                                        <DKLine className="bg-red z-index-2" style={{
                                                            position: 'absolute',
                                                            height: 2,
                                                            top: ((parseInt(moment().format('mm')) * this.timeLineHeight) / 60)
                                                        }} />
                                                    </div>
                                                }
                                                {/* Tasks */}
                                                {this.renderTask(new Date(this.state?.weekDays[index]), hour)}
                                            </td>
                                        )
                                    })}
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
        </div>
        )
    }
}

export default WeekViewCalendar;
